import axios from 'axios'

const API_BASE = import.meta.env.VITE_API_URL || '/api'

const SENSITIVE_PATHS = ['/auth/login', '/auth/register', '/auth/reset-password', '/auth/forgot-password']

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
})

function isSensitiveRequest(url) {
  if (!url) return false
  return SENSITIVE_PATHS.some(path => url.includes(path))
}

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  if (import.meta.env.DEV && !isSensitiveRequest(config.url)) {
    console.log('[API Request]', {
      method: config.method?.toUpperCase(),
      url: config.url,
    })
  }

  return config
})

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !String(error.config?.url || '').includes('/advisor/')) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
